<template>
  <v-card style=" margin: 0 auto;border-radius:16px;">
    <v-container >
      <v-flex v-if="isOwner" xs12 style="text-align:right;">
        <v-btn @click="onEdit" outline color="primary" small><v-icon>edit</v-icon>編集する</v-btn>
      </v-flex>
      <v-flex xs12 style="text-align:left;position:relative;margin-bottom:16px;">
        <carousel :per-page="1" style="text-align:center;">
          <slide v-for="(imageurl, id) in imageurls" :key=id>
            <v-img :src="imageurl"
              :lazy-src="require('@/assets/img/icon_loader.gif')"
              style="max-width:400px;max-height:500px;min-height:200px;margin:0 auto;" :alt="`${food.name}の画像`"
            />
          </slide>
        </carousel>
      </v-flex>
      <v-flex xs12 style="text-align:left;">
          <span v-if="food.hotScore>0" style="font-weight:bold;margin-right:10px;font-size:120%;">
            辛さ：{{food.hotScore | showRating}}
          </span>
          <span v-if="food.tasteScore>0" style="font-weight:bold;font-size:120%;">
            味：{{food.tasteScore | showRating}}
          </span>
        </v-flex>
      <v-layout row wrap style="margin: 16px 0;">
        <v-flex xs12 style="text-align:left;">
          <template v-if="tabetaiCount>0" class="primary--text">
            <v-chip small color="primary" dark label><v-icon>favorite_outline</v-icon>{{tabetaiCount}}件</v-chip>
          </template>
          <template v-if="postCount>0" class="primary--text">
            <v-chip @click="scroll2Review" small color="primary" outline label>カラログ：{{postCount}}件</v-chip>
          </template>
          <template v-if="snsCount>0" class="primary--text">
            <v-chip @click="scroll2Sns" small color="primary" outline label>SNS：{{snsCount}}件</v-chip>
          </template>
        </v-flex>
      </v-layout>
      <v-flex xs12 style="text-align:left;">
        <h1 class="headline" style="font-weight: bold;margin-bottom:16px">{{food.name}}</h1>
        <p v-html="$options.filters.changeBR(food.description)"></p>
        <p>
          <v-chip v-if="food.categoryname" small label dark color="primary">{{food.categoryname.value}}</v-chip>
          <v-chip v-for="(tag, id) in displayTag" color="red" outline small :key=id>{{tag}}</v-chip>
        </p>
      </v-flex>
      <v-layout v-if="hasDetail" row wrap>
        <h2 class="title komidashi">食品の詳細情報</h2>
        <v-flex xs12 v-show="!showFoodDetail">
          <v-btn @click="showFoodDetail=true" small outline flat block color="grey darken-2" round>詳細情報を表示する</v-btn>
        </v-flex>
        <v-flex xs12 v-show="showFoodDetail">
          <table id="foodDetail">
            <tr>
              <td class="foodDetailLabel">メーカー</td>
              <td class="foodDetailContent">{{maker}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">ブランド</td>
              <td class="foodDetailContent">{{brand}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">希望小売価格</td>
              <td class="foodDetailContent">{{makerPrice}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">カロリー</td>
              <td class="foodDetailContent">{{kcal}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">内容量</td>
              <td class="foodDetailContent">{{content}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">発売日</td>
              <td class="foodDetailContent">{{releaseDate}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">Janコード</td>
              <td class="foodDetailContent">{{jan}}</td>
            </tr>
            <tr>
              <td class="foodDetailLabel">メーカーサイト</td>
              <td class="foodDetailContent">
                <a v-if="makerURL!==undefinedText" :href="makerURL" target="_blank">メーカーサイトへ</a>
                <span v-else>{{makerURL}}</span>                
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
      <v-layout v-if="materials!==undefinedText" row wrap style="margin-top: 16px;">
        <h2 class="title komidashi">食品の原材料</h2>
        <v-flex xs12 v-show="!showFoodMaterials">
          <v-btn @click="showFoodMaterials=true" small outline flat block color="grey darken-2" round>原材料を表示する</v-btn>
        </v-flex>
        <v-flex xs12 v-show="showFoodMaterials">
          <p style="text-align:left;" v-html="$options.filters.changeBR(materials)"></p>
        </v-flex>
      </v-layout>
      <!-- レビュー一覧 -->
      <v-layout row wrap style="margin: 10px 0;">
        <h2 class="title komidashi" id="reviewTop">みんなのカラログ</h2>
        <v-flex xs12 v-if="postCount>0">
          <review-card
          @onReviewCardClick="onReviewCardClick"
          :post=p v-for="(p, id) in posts" :key=id
          style="margin-bottom:16px;">
          </review-card>
        </v-flex>
        <v-flex xs12 v-else style="padding:10px;">
          <p>まだカラログは投稿されてません。</p>
          <v-btn @click="onReview" color="primary" outline block><v-icon>add</v-icon>&nbsp;カラログを投稿する</v-btn>
        </v-flex>
      </v-layout>
      <!-- ／レビュー一覧 -->
      <!-- SNSの反応・感想一覧-->
      <v-layout v-if="isSnsUrl" row wrap>
        <h2 class="title komidashi" id="snsTop">SNSの反応・評価</h2>
        <v-flex xs12>
          <sns-card
          :url=url v-for="(url, id) in food.snsUrls" :key=id
          style="margin-bottom:16px;">
          </sns-card>
        </v-flex>
      </v-layout>
      <!-- /SNSの反応・感想一覧-->
      <sns-buttons></sns-buttons>
    </v-container>
      <div style="position:sticky;z-index:2;bottom:0px;padding:5px 0;background: rgba(255,255,255,1);border-top:solid 1px #ddd;">
        <div style="text-align:center;width:100%;overflow-x: auto;white-space:nowrap;">
          <v-btn
            v-if="isTabetai"
            @click="onDeleteTabetai" round large color="white"
            style="border: solid 2px #F44336 !important;padding:0 10px;color:#F44336"
            >
            <v-icon>favorite</v-icon>
            カライイネ
          </v-btn>
          <v-btn
            v-else
            @click="onTabetai" round large color="white"
            style="border: solid 2px #757575 !important;padding:0 10px;color:#757575"
            >
            <v-icon>favorite_border</v-icon>
            カライイネ
          </v-btn>
          <v-btn
            @click="onReview"
            round large dark color="primary"
            style="border: solid 2px #F44336 !important;padding:0 15px;"
            >
            <v-icon>edit</v-icon>カラログ
          </v-btn>
        </div>
      </div>
  </v-card>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { db } from '@/main'
import ReviewCard from '@/components/card/ReviewCard.vue'
import SnsCard from '@/components/card/SnsCard.vue'
import SnsButtons from '@/components/common/SnsButtons.vue'

export default {
  name: 'FoodCard',
  data () {
    return {
      posts: [],
      showFoodMaterials: true,
      showFoodDetail: true,
      undefinedText: '---',
      isSnsUrl: false
    }
  },
  props: {
    food: Object,
    imageurls: Array
  },
  computed: {
    displayTag () {
      if (this.food.tags) return Object.keys(this.food.tags)
      return []      
    },
    isOwner () {
      if (this.food.user.uid == this.$store.state.user.uid) {
        return true
      } else if (this.$store.state.user.uid === 'I84vaBSDnMgCVzeOd8X1nrzzzBG3') {
        return true
      }
      return false
    },
    isTabetai () {
      if (this.$store.getters.getTabetaiById(this.food.id)) {
        return true
      }
      return false
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    maker () {
      if (this.food.maker) return this.food.maker
      return this.undefinedText
    },
    brand () {
      if (this.food.brand) return this.food.brand
      return this.undefinedText
    },
    makerPrice () {
      if (this.food.makerPrice) return this.food.makerPrice + '円'
      return this.undefinedText
    },
    kcal () {
      if (this.food.kcal) return this.food.kcal + 'kcal'
      return this.undefinedText
    },
    content () {
      if (this.food.content) return this.food.content + 'g'
      return this.undefinedText
    },
    releaseDate () {
      if (this.food.releaseDate) return this.food.releaseDate
      return this.undefinedText
    },
    jan () {
      if (this.food.jan) return this.food.jan
      return this.undefinedText
    },
    materials () {
      if (this.food.materials) return this.food.materials
      return this.undefinedText
    },
    makerURL () {
      if (this.food.makerURL) return this.food.makerURL
      return this.undefinedText
    },
    hasDetail () {
      if (this.maker !== this.undefinedText) return true
      if (this.brand !== this.undefinedText) return true
      if (this.makerPrice !== this.undefinedText) return true
      if (this.kcal !== this.undefinedText) return true
      if (this.content !== this.undefinedText) return true
      if (this.releaseDate !== this.undefinedText) return true
      if (this.jan !== this.undefinedText) return true
      return false
    },
    postCount () {
      if (this.food.postCount) {
        if (this.food.postCount > 0) {
          return this.food.postCount
        }
        return 0
      }
      return 0
    },
    tabetaiCount () {
      if (this.food.tabetaiCount) {
        if (this.food.tabetaiCount > 0) {
          return this.food.tabetaiCount
        }
        return 0
      }
      return 0
    },
    snsCount () {
      if (this.food.snsUrls) {
        return this.food.snsUrls.length
      }
      return 0
    },
  },
  watch: {
    food () {
      this.init()
    }
  },
  filters: {
    changeBR (v) {
      if (v) return v.replace(/\r?\n/g, '<br>')
      return ''
    },
    showRating: function (v) {
      v = v + ''
      if (v.length === 1) {
        v = v + '.000'
      } else {
        v = v + '00'
      }
      return v.substring(0, 4)
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.posts = []
      this.showFoodMaterials = true
      this.showFoodDetail = true
      this.undefinedText = '---'
      this.isSnsUrl = false

      this.getPosts()
      if (this.postCount > 0) {
          this.showFoodMaterials = false
          this.showFoodDetail = false
      } 
      if (this.food.snsUrls) {
        if (this.food.snsUrls.length > 0) {
          this.showFoodMaterials = false
          this.showFoodDetail = false
          this.isSnsUrl = true
        }
      }
    },
    onEdit () {
      this.$store.commit('setTempId', this.food.id)
      this.$store.commit('setTempFoodData', this.food)
      this.$store.commit('setTempImages', this.imageurls)
      
      this.$router.push({name: 'updateFood'})
    },
    onReview () {
      if (this.isLogin) {
        this.$store.commit('setTempId', this.food.id)
        this.$store.commit('setTempFoodData', this.food)
        this.$store.commit('setTempImages', this.imageurls)

        this.$router.push({name: 'reviewPostView'})
      } else {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '',
          text: 'カラログ投稿にはログインが必要です。'
        }
        this.$emit('onMessage', obj)
      }
    },
    async getPosts () {
      let response = await db.collection('post').where('food.id','==', this.food.id).orderBy('timestamp', 'desc').get()
      response.forEach((doc) => {
        let p = doc.data()
        p.id = doc.id
        this.posts.push(p)
      })
    },
    onReviewCardClick (post) {
      this.$router.push({name: 'searchReviewDetail', params: {id: post.id}})
    },
    onTabetai () {
      if (this.isLogin) {
        let tabetai = this.getTabetai()
        this.$store.dispatch('addTabetai', tabetai)
        let obj = {
          group: 'messageBottom',
          type: 'success',
          title: 'カライイネ！しました。'
        }
        this.$emit('onMessage', obj)
      } else {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: 'カライイネするにはログインが必要です。'
        }
        this.$emit('onMessage', obj)
      }
    },
    onDeleteTabetai () {
      let tabetai = this.getTabetai()
      this.$store.dispatch('deleteTabetai', tabetai)
      let obj = {
          group: 'messageBottom',
          type: 'success',
          title: 'カライイネ！を取り消しました。'
        }
        this.$emit('onMessage', obj)
    },
    getTabetai () {
      let tabetai = {
        id: this.food.id,
        name: this.food.name,
        imageurl: this.food.images[0]
      }
      return tabetai
    },
    scroll2Review () {
      let target = document.getElementById('reviewTop')
      this.$SmoothScroll(target, 500, undefined, undefined, 'y')
    },
    scroll2Sns () {
      let target = document.getElementById('snsTop')
      this.$SmoothScroll(target, 500, undefined, undefined, 'y')
    }
  },
  components: {
    Carousel,
    Slide,
    ReviewCard,
    SnsButtons,
    SnsCard
  }
}
</script>

<style scoped>
#foodDetail {
  text-align: left;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  width: 100%;
  max-width:400px;
}
#foodDetail tr td {
  padding: 5px 10px;
}
#foodDetail tr td.foodDetailLabel {
  background-color: #eee;
  font-weight: bold;
}
.VueCarousel-dot--active {
  background-color: #f44336 !important;
}
.komidashi {
  font-weight: bold;
  margin-top:5px;
  margin-bottom:7px;
}
</style>